import { ChangeLogEntityType, useGetChangeLogByEntity } from '../../../../../api/created/changeLog.ts';
import type { AddressContactDto } from '../../../../../api/generated/model/addressContactDto';
import { useUsers } from '../../../../../api/created/users.ts';
import { ChangeHistoryModal } from '../../../../../components/history/ChangeHistoryModal.tsx';
import { mapChangeLogEntriesToContactPersonHistory } from './contactPersonHistory.ts';

type ContactPersonHistoryModalProps = {
  open: boolean;
  onClose: () => void;
  contact: AddressContactDto | null;
};

function getContactPersonName(contact: AddressContactDto | null) {
  const name = [contact?.firstName, contact?.lastName].filter(Boolean).join(' ').trim();
  return name || 'Ansprechperson';
}

export function ContactPersonHistoryModal({ open, onClose, contact }: ContactPersonHistoryModalProps) {
  const contactId = contact?.id;
  const { data: changeLogEntries = [], isLoading } = useGetChangeLogByEntity(
    ChangeLogEntityType.ADDRESS_CONTACT,
    contactId,
    {
      enabled: open && !!contactId,
    },
  );
  const { data: users = [] } = useUsers({ enabled: open && !!contactId });
  const historyEntries = mapChangeLogEntriesToContactPersonHistory(changeLogEntries, { users });
  const contactName = getContactPersonName(contact);

  return (
    <ChangeHistoryModal
      open={open}
      onClose={onClose}
      title={`Verlauf – ${contactName}`}
      subject="Die Ansprechperson"
      entityName={contactName}
      entries={historyEntries.map((entry) => ({
        ...entry,
        changedBy: entry.changedByName,
      }))}
      isLoading={isLoading}
    />
  );
}
